import WebsiteBehaviors from "../website-behaviors/index.js";

class Wikipedia extends WebsiteBehaviors {
	identifier() {
		return "Wikipedia";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "wikipedia.org"
				|| location.host.endsWith(".wikipedia.org"));
	}

	styles() {
		// language=CSS
		return `
			body {
				overflow-y: initial;
			}
		`;
	}
}

export default Wikipedia;
